import { PATCH } from "../API";
let source = null;

export const updateUserApi = (data, onSuccess, onError) => {

    source = PATCH(`/api/v1/identity/users/update`, data, onSuccess, onError, true, source);
};